import Utils from "../../js/utils";

export const getAgrCount = ({ ipDetails, chartWidth }) => {
    const { epoch, graphType, accuracy } = ipDetails;
    const level = accuracy === 'normal' ? 0 : 1; // [low - 0, high - 1]
    const isBasic = graphType === 'basic';
    // -----------  calculate aggregation --------------
    const basicThreshold = { min: 5, normal: chartWidth * 0.5, high: chartWidth * 2 };
    const advancedThreshold = { min: 30, normal: chartWidth * 0.1, high: chartWidth * 0.5 };
    const threshold = isBasic ? basicThreshold : advancedThreshold;
    //--------
    const valueCount = level ? threshold.high : threshold.normal;
    let agrCount = epoch / valueCount;
    agrCount = agrCount < threshold.min ? threshold.min : agrCount;
    // -------------------------------------------------
    // AGRCOUNT - represents number of seconds to aggregate together
    return Math.ceil(agrCount);
}
